<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" (click)="goToHome()"><img src="assets/img/logo.png" style="cursor: pointer"></a>

    <div class="collapse navbar-collapse">
      <div class="navbar-nav">
        <div class="nav-item" (click)="goToHome()">
          <app-nav-link [text]="'navigation.orders'"></app-nav-link>
        </div>
      </div>
    </div>

    <div class="right-shift">
      <div class="navbar-nav">
        <div class="nav-item ml-3" *ngIf="isGroupAccount">
          <div style="display: inline-flex;">
            <form [formGroup]="searchForm">
              <div style="display: inline-flex">
                <input placeholder="{{currentUser.account.customerNumber}}" class="form-control parameter-input customer-search" [matAutocomplete]="auto" formControlName="searchBar">
                <button (click)="changeAccount()" class="clear-button"><img src="assets/img/icons/activated.svg" style="width: 30px;"></button>
              </div>
              <mat-autocomplete #auto="matAutocomplete">
                <ng-container>
                  <mat-option *ngFor="let option of searchResult" [value]="option.customerNumber">
                    <span>{{ option.customerNumber + ' ' + option.customerName}}</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </form>
          </div>
        </div>
        <div class="nav-item ml-3">
          <app-new-order-picker></app-new-order-picker>
        </div>
        <div class="nav-item ml-3">
          <app-language-picker></app-language-picker>
        </div>
        <div class="nav-item ml-3">
          <app-cart></app-cart>
        </div>
        <div class="nav-item ml-3 admin-settings" *ngIf="isAdmin$ | async">
          <img src="assets/img/icons/settings.svg" (click)="goToAdmin()"/>
        </div>
        <div class="nav-item ml-3">
          <app-nav-link [text]="'navigation.logout'" (click)="logout()"></app-nav-link>
        </div>
      </div>
    </div>

</nav>
